<div class="container">
  <h1>{{ isEdit ? 'Edit' : 'Add' }} Insurance Loan</h1>
  
  <mat-card>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <!-- Loan Information -->
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" required>
            <mat-hint>Enter the loan name</mat-hint>
            @if(form.get('name')?.hasError('required')) {
              <mat-error>
                Name is required
              </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- State Field -->
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>State</mat-label>
            <mat-select formControlName="state" required>
              <mat-option *ngFor="let option of stateOptions" [value]="option.value">
                {{option.label}}
              </mat-option>
            </mat-select>
            <mat-hint>Select the state for this loan</mat-hint>
            @if(form.get('state')?.hasError('required')) {
              <mat-error>
                State is required
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Close Date</mat-label>
            <input matInput formControlName="close_date" [matDatepicker]="closeDatePicker">
            <mat-datepicker-toggle matSuffix [for]="closeDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #closeDatePicker></mat-datepicker>
            <mat-hint>Select the close date for this loan</mat-hint>
            @if(form.get('close_date')?.hasError('required')) {
              <mat-error>
                Close date is required
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Amount</mat-label>
            <input matInput type="text" formControlName="amount" required numberFormat>
            <span matPrefix>&nbsp;$&nbsp;</span>
            <mat-hint>Enter the loan amount</mat-hint>
            @if(form.get('amount')?.hasError('required')) {
              <mat-error>
                Amount is required
              </mat-error>
            }
            @if(form.get('amount')?.hasError('min')) {
              <mat-error>
                Amount must be greater than 0
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Interest Fee</mat-label>
            <input matInput type="text" formControlName="interest_fee" required numberFormat>
            <span matPrefix>&nbsp;$&nbsp;</span>
            <mat-hint>Enter the interest fee amount</mat-hint>
            @if(form.get('interest_fee')?.hasError('required')) {
              <mat-error>
                Interest fee is required
              </mat-error>
            }
            @if(form.get('interest_fee')?.hasError('min')) {
              <mat-error>
                Interest fee must be greater than 0
              </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Fund to Bank Option -->
        <div class="form-row">
          <div class="field-container full-width">
            <mat-checkbox formControlName="fundToBank" color="primary">
              Fund to Bank
            </mat-checkbox>
            <div class="checkbox-help-text">
              Check this to automatically create a transaction that adds these funds to the selected bank (requires selecting a bank)
            </div>
          </div>
        </div>

        @if(form.get('fundToBank')?.value) {
          <!-- Bank Field -->
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Bank</mat-label>
              <mat-select formControlName="bank_id">
                @for (bank of banks(); track bank.id) {
                  <mat-option [value]="bank.id">
                    {{bank.name}}
                  </mat-option>
                }
                @if(banks().length === 0) {
                  <mat-option disabled>
                    No banks found. Please add a bank first.
                  </mat-option>
                }
              </mat-select>
              <mat-hint>Select the bank for this loan</mat-hint>
              @if(form.get('bank_id')?.hasError('required') && form.get('bank_id')?.touched) {
                <mat-error>
                  Bank is required when "Fund to Bank" is checked
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        <div class="form-actions">
          <button mat-button type="button" (click)="onCancel()">Cancel</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="!form.valid">
            {{ isEdit ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
